<template>
  <div class="left_container">
    <div
      style="
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: calc(100% - 30px);
      "
    >
      <div class="head_div">
        <el-upload
          :action="avatarUrl"
          :headers="myHeaders"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          :disabled="true"
          accept=".jpg,.png,.jpeg"
          class="avatar-uploader"
        >
          <img :src="imgUrl" class="header_icon" />
          <div class="header_nickname barnick_color">
            {{ util.getLocalAccount().dep.depName }}
          </div>
          <div
            class="header_nickname barnick_color"
            v-show="util.getLocalAccount().realName != null"
          >
            {{ util.getLocalAccount().realName }}
          </div>
        </el-upload>
        <div
          class="online_text onlinetip_color"
          v-if="iState == 1"
        >
          <span>{{ nowState }}</span>
          <span>{{ nowTimeLength === "0秒" ? "刚刚" : nowTimeLength }}</span>
        </div>
        <div
          class="busy_text busytip_color"
          v-if="iState == 2"
        >
          <span>{{ nowState }}</span>
          <span>{{ nowTimeLength === "0秒" ? "刚刚" : nowTimeLength }}</span>
        </div>
        <div
          class="leave_text leavetip_color"
          v-if="iState == 0"
        >
          <span>{{ nowState }}</span>
          <span>{{ nowTimeLength === "0秒" ? "刚刚" : nowTimeLength }}</span>
        </div>

        <div class="statusList">
          <div
            v-if="isOnLine"
            class="baronstateselected_div font_type"
            @click="clickState('在线', 1)"
          >
            在线
          </div>
          <div
            v-else
            class="baronstate_div font_type"
            @click="clickState('在线', 1)"
          >
            在线
          </div>

          <div
            v-if="isBusy"
            class="barbusyselected_div font_type"
            @click="clickState('忙碌', 2)"
          >
            忙碌
          </div>
          <div
            v-else
            class="barbusystate_div font_type"
            @click="clickState('忙碌', 2)"
          >
            忙碌
          </div>

          <div
            v-if="isLeave"
            class="barlveselected_div font_type"
            @click="clickState('离开', 0)"
          >
            离开
          </div>
          <div
            v-else
            class="barlvestate_div font_type"
            @click="clickState('离开', 0)"
          >
            离开
          </div>

          <div class="baroff_div font_type" @click="clickState1(4)">退出</div>
          <div class="baroff_div font_type" @click="reloadPage">刷新</div>
        </div>
      </div>

      <!--		<div class="op_div">
			<router-link :to="{name:'setting', query: { enterId: '0' }}" v-show="$store.state.authority.isShowLog">
				<img id="logImg" v-if="logSelected" title="日志查看" class="img_div" src="../../static/talks/t_loged.png" 
				@click="clickIcon(0)" @mouseover="hover($event, '0')" @mouseout ="unhover($event, '0')"/>
				<img v-else class="img_div" title="日志查看" src="../../static/talks/t_log.png" 
				@click="clickIcon(0)" @mouseover="hover($event, '0')" @mouseout ="unhover($event, '0')"/>
			</router-link>
			
			&lt;!&ndash; <router-link :to="{name:'setting', query: { enterId: '1' }}" v-show="$store.state.authority.isShowRecord">
				<img v-if="reportSelected" title="会话统计"  class="img_div" src="../../static/talks/t_reported.png" 
				@click="clickIcon(1)" @mouseover="hover($event, '1')" @mouseout ="unhover($event, '1')"/>
				<img v-else class="img_div" title="会话统计"  src="../../static/talks/t_report.png" 
				@click="clickIcon(1)" @mouseover="hover($event, '1')" @mouseout ="unhover($event, '1')"/>
			</router-link> &ndash;&gt;
			
			<img v-if="talkSelected" title="会话"  class="img_div" src="../../static/talks/t_talked.png" @click="clickIcon(2)" />
			<img v-else class="img_div" title="会话"  src="../../static/talks/t_talk.png" @click="clickIcon(2)"/>
			
			<router-link :to="{name:'setting', query: { enterId: '3' }}" v-show="$store.state.authority.isShowWord">
				<img v-if="wordSelected" title="留言"  class="img_div" src="../../static/talks/t_worded.png" 
				@click="clickIcon(3)" @mouseover="hover($event, '3')" @mouseout ="unhover($event, '3')"/>
				<img v-else class="img_div" title="留言"  src="../../static/talks/t_word.png"
				@click="clickIcon(3)" @mouseover="hover($event, '3')" @mouseout ="unhover($event, '3')"/>	
			</router-link>
			
			<router-link :to="{name:'setting', query: { enterId: '4' }}">
				<img v-if="settingSelected" title="设置"  class="img_div" src="../../static/talks/t_settinged.png" 
				@click="clickIcon(4)" @mouseover="hover($event, '4')" @mouseout ="unhover($event, '4')"/>
				<img v-else class="img_div" title="设置"  src="../../static/talks/t_setting.png" 
				@click="clickIcon(4)" @mouseover="hover($event, '4')" @mouseout ="unhover($event, '4')"/>
			</router-link>
			
			<router-link :to="{name:'setting', query: { enterId: '2' }}" v-show="$store.state.authority.isShowRecord">
				<img v-if="reportSelected" title="会话统计"  class="img_div" src="../../static/talks/t_reported.png" 
				@click="clickIcon(1)" @mouseover="hover($event, '2')" @mouseout ="unhover($event, '2')"/>
				<img v-else class="img_div" title="会话统计"  src="../../static/talks/t_report.png" 
				@click="clickIcon(1)" @mouseover="hover($event, '2')" @mouseout ="unhover($event, '2')"/>
			</router-link>
			
			<router-link :to="{name:'setting', query: { enterId: '5' }}">
				<img v-if="reportSelected" title="报表统计"  class="img_div" src="../../static/talks/t_reported1.png" 
				@click="clickIcon(5)" @mouseover="hover($event, '5')" @mouseout ="unhover($event, '5')"/>
				<img v-else class="img_div" title="报表统计"  src="../../static/talks/t_report1.png" 
				@click="clickIcon(5)" @mouseover="hover($event, '5')" @mouseout ="unhover($event, '5')"/>
			</router-link>
			
		</div>-->

      <div class="op_div">
        <!-- <div v-show="$store.state.authority.isShowLog">
          <img
            id="logImg"
            v-if="logSelected"
            title="日志查看"
            class="img_div"
            src="../../static/talks/t_loged.png"
            @click="clickIcon(0, '日志查看')"
            @mouseover="hover($event, '0')"
            @mouseout="unhover($event, '0')"
          />
          <img
            v-else
            class="img_div"
            title="日志查看"
            src="../../static/talks/t_log.png"
            @click="clickIcon(0, '日志查看')"
            @mouseover="hover($event, '0')"
            @mouseout="unhover($event, '0')"
          />
        </div> -->

        <!-- <router-link :to="{name:'setting', query: { enterId: '1' }}" v-show="$store.state.authority.isShowRecord">
        <img v-if="reportSelected" title="会话统计"  class="img_div" src="../../static/talks/t_reported.png"
        @click="clickIcon(1)" @mouseover="hover($event, '1')" @mouseout ="unhover($event, '1')"/>
        <img v-else class="img_div" title="会话统计"  src="../../static/talks/t_report.png"
        @click="clickIcon(1)" @mouseover="hover($event, '1')" @mouseout ="unhover($event, '1')"/>
      </router-link> -->

        <img
          v-if="talkSelected"
          title="会话"
          class="img_div"
          src="../../static/talks/t_talked.png"
        />
        <!-- @click="clickIcon(2)" -->
        <img
          v-else
          class="img_div"
          title="会话"
          src="../../static/talks/t_talk.png"
        />
        <!-- @click="clickIcon(2)" -->

        <!-- <div v-show="$store.state.authority.isShowWord">
          <img
            v-if="wordSelected"
            title="留言"
            class="img_div"
            src="../../static/talks/t_worded.png"
            @click="clickIcon(3, '留言')"
            @mouseover="hover($event, '3')"
            @mouseout="unhover($event, '3')"
          />
          <img
            v-else
            class="img_div"
            title="留言"
            src="../../static/talks/t_word.png"
            @click="clickIcon(3, '留言')"
            @mouseover="hover($event, '3')"
            @mouseout="unhover($event, '3')"
          />
        </div> -->

<!--          <div>
          <img
            v-if="wordSelected"
            title="留言管理"
            class="img_div"
            src="../../static/talks/t_worded.png"
            @click="clickIcon(3, '留言管理')"
            @mouseover="hover($event, '3')"
            @mouseout="unhover($event, '3')"
          />
          <img
            v-else
            class="img_div"
            title="留言管理"
            src="../../static/talks/t_word.png"
            @click="clickIcon(3, '留言管理')"
            @mouseover="hover($event, '3')"
            @mouseout="unhover($event, '3')"
          />
        </div>-->

        <div v-show="$store.state.authority.isShowRecord" class="session-report-wrap">
          <img
            v-if="reportSelected"
            title="会话统计"
            class="img_div"
            src="../../static/talks/t_reported.png"
            @click="goSessionReport('old')"
            @mouseover="hover($event, '2')"
            @mouseout="unhover($event, '2')"
          />
          <img
            v-else
            class="img_div"
            title="会话统计"
            src="../../static/talks/t_report.png"
            @click="goSessionReport('old')"
            @mouseover="hover($event, '2')"
            @mouseout="unhover($event, '2')"
          />
        </div>
        <div>
          <!-- @click="linkTo('5')" -->
          <img
            v-if="reportSelected"
            title="登录日志"
            class="img_div"
            src="../../static/talks/t_loginLog.png"
            @click="clickIcon(6, '登录日志')"
            @mouseover="hover($event, '6')"
            @mouseout="unhover($event, '6')"
          />
          <img
            v-else
            class="img_div"
            title="登录日志"
            src="../../static/talks/t_loginLog.png"
            @click="clickIcon(6, '登录日志')"
            @mouseover="hover($event, '6')"
            @mouseout="unhover($event, '6')"
          />
        </div>
        <div>
          <!-- @click="linkTo('5')" -->
          <img
            v-if="reportSelected"
            title="时长统计"
            class="img_div"
            src="../../static/talks/t_reported1.png"
            @click="clickIcon(5, '时长统计')"
            @mouseover="hover($event, '5')"
            @mouseout="unhover($event, '5')"
          />
          <img
            v-else
            class="img_div"
            title="时长统计"
            src="../../static/talks/t_report1.png"
            @click="clickIcon(5, '时长统计')"
            @mouseover="hover($event, '5')"
            @mouseout="unhover($event, '5')"
          />
        </div>
        <div>
          <!-- @click="linkTo('4')" -->
          <img
            v-if="settingSelected"
            title="设置"
            class="img_div"
            src="../../static/talks/t_settinged.png"
            @click="clickIcon(4, '设置')"
            @mouseover="hover($event, '4')"
            @mouseout="unhover($event, '4')"
          />
          <img
            v-else
            class="img_div"
            title="设置"
            src="../../static/talks/t_setting.png"
            @click="clickIcon(4, '设置')"
            @mouseover="hover($event, '4')"
            @mouseout="unhover($event, '4')"
          />
        </div>
      </div>
    </div>

    <div class="version_div">
      <div>{{ version }}</div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import router from "../router/index.js";
import config from "../utils/electronConfig.js";

export default {
  name: "leftBar",

  props: ["isLeaved"],

  data() {
    return {
      stateList: ["在线", "忙碌", "离开", "个人设置", "退出"],
      logSelected: false,
      talkSelected: true,
      reportSelected: false,
      settingSelected: false,
      wordSelected: false,
      sessionReportPopVisible: false,
      nowState: "在线",
      iState: Number((this.util.getLocalAccount() || {}).userStatus || 1), //1-在线 2-忙碌 0-离开
      isOnLine: true,
      isBusy: false,
      isLeave: false,
      prevStatusSnapshot: null,
      skipStatusRequest: false,
      avatarUrl:
        JSON.parse(localStorage.getItem("siteObj")).webUrl +
        "/manager/fileInfo/pass/upload",
      myHeaders: {
        Authorization: localStorage.getItem("token"),
      },
      imgUrl: require("../../static/talks/t_severbig.png"),
      version: localStorage.getItem("version"),
      leftBarWidth: 0,
      afterWidth: 0,
      flag: true,
    };
  },

  computed: {
    nowTimeLength() {
      return this.$store.state.authority.timeLength;
    },
  },

  watch: {
    isLeaved(newVal, oldVal) {
      console.log("leftBar isLeave newVal = ", newVal);
      console.log("leftBar isLeave oldVal = ", oldVal);
      if (newVal === true) {
        this.iState = 0;

        var account = this.util.getLocalAccount();
        account.userStatus = this.iState;
        account.timeLength = "0秒";
        this.util.setLocalAccount(JSON.stringify(account));
        this.$store.state.authority.timeLength = "0秒";
        this.$store.state.authority.userStatus = this.iState;

        this.nowState = "离开";
        this.isLeave = true;
        this.isOnLine = false;
        this.isBusy = false;
      }
    },

    iState(newVal, oldVal) {
      console.log("leftBar iState newVal = ", newVal);
      console.log("leftBar iState oldVal = ", oldVal);

      if (newVal == oldVal) {
        return;
      }

      if (newVal == 0) {
        return;
      }

      if (this.skipStatusRequest) {
        return;
      }

      this.setStateRequest();
    },
  },

  created() {
    console.log(
      "leftBar created islog = ",
      this.$store.state.authority.isShowLog
    );
    console.log(
      "leftBar created isword = ",
      this.$store.state.authority.isShowWord
    );
    console.log("leftBar timelength = ", this.timeLength);
  },

  mounted() {
    const account = this.util.getLocalAccount();
    console.log("客服基础信息", account);
    if (account.logoUrl !== null) {
      if (account.logoUrl.length !== 0) {
        this.imgUrl = account.logoUrl;
      }
    }

    this.iState = Number(account.userStatus);
    console.log("istate = ", this.iState);
    if (this.iState === 1) {
      this.nowState = "在线";
      this.isOnLine = true;
      this.isBusy = false;
      this.isLeave = false;
    } else if (this.iState === 2) {
      this.nowState = "忙碌";
      this.isOnLine = false;
      this.isBusy = true;
      this.isLeave = false;
    } else if (this.iState === 0) {
      this.nowState = "离开";
      this.isOnLine = false;
      this.isBusy = false;
      this.isLeave = true;
    }
    this.$store.state.authority.userStatus = this.iState;
    this.setNavIconSize();
    window.addEventListener("resize", () => {
      this.setNavIconSize();
    });
    window.addEventListener("storage", (e) => {
      if (e.key === "avatar") {
        this.imgUrl = localStorage.getItem("avatar");
      }
    });
    // this.leftBarWidth = document.body.clientWidth;
    // // console.log(this.util.getLocalAccount())
    // this.$nextTick(() =>{
    // 	window.addEventListener('resize', ()=>{
    // 		var isFirefox = navigator.userAgent.indexOf("Firefox")>0||navigator.userAgent.indexOf("MSIE")>0||navigator.userAgent.indexOf("MSIE")
    // 		console.log("页面resize",isFirefox)

    // 		if(isFirefox!=undefined){
    // 			this.zoomout()
    // 			window.location.reload();
    // 			// window.onresize(function (){
    // 			// 	window.location.reload();
    // 			// });
    // 		}
    // 	})
    // })

    // if(isFirefox!=undefined){

    // 	window.resize(function (){
    // 		window.location.reload();
    // 	});
    // }
  },

  methods: {
    reloadPage() {
      if (this.flag) {
        this.flag = false;
        window.location.reload();
        setTimeout(() => {
          this.flag = true;
        }, 1000);
      }
    },

    clickSetting() {
      console.log("leftBar clickSetting Action");
      this.$emit("clickSetting");
    },

    clickState1(index) {
      console.log("leftBar clickState1 index = ", index);
      if (index === 3) {
        //个人设置
        this.$emit("toSetting", 0);
      } else if (index === 4) {
        //退出
        this.$emit("logout");
      }
    },

    hover(element, index) {
      // console.log('leftBar hover e = ', element.target)

      if (index === "0") {
        element.target.src = require("../../static/talks/t_loged.png");
      } else if (index === "1") {
        element.target.src = require("../../static/talks/t_reported.png");
      } else if (index === "3") {
        element.target.src = require("../../static/talks/t_worded.png");
      } else if (index === "4") {
        element.target.src = require("../../static/talks/t_settinged.png");
      } else if (index === "2") {
        element.target.src = require("../../static/talks/t_reported.png");
      } else if (index === "5") {
        element.target.src = require("../../static/talks/t_reported1.png");
      } else if (index === "6") {
        element.target.src = require("../../static/talks/t_loginLoged.png");
      }
    },

    unhover(element, index) {
      if (index === "0") {
        element.target.src = require("../../static/talks/t_log.png");
      } else if (index === "1") {
        element.target.src = require("../../static/talks/t_report.png");
      } else if (index === "3") {
        element.target.src = require("../../static/talks/t_word.png");
      } else if (index === "4") {
        element.target.src = require("../../static/talks/t_setting.png");
      } else if (index === "2") {
        element.target.src = require("../../static/talks/t_report.png");
      } else if (index === "5") {
        element.target.src = require("../../static/talks/t_report1.png");
      } else if (index === "6") {
        element.target.src = require("../../static/talks/t_loginLog.png");
      }
    },

    applyLocalStatus(status, stateName, options = {}) {
      const next = Number(status);
      const skipRequest = !!options.skipRequest;
      if (skipRequest) {
        this.skipStatusRequest = true;
      }
      this.iState = next;
      this.nowState = stateName;
      this.isOnLine = next === 1;
      this.isBusy = next === 2;
      this.isLeave = next === 0;
      const account = this.util.getLocalAccount() || {};
      account.userStatus = next;
      account.timeLength = "0秒";
      this.util.setLocalAccount(JSON.stringify(account));
      this.$store.state.authority.timeLength = "0秒";
      this.$store.state.authority.userStatus = next;
      if (skipRequest) {
        this.$nextTick(() => {
          this.skipStatusRequest = false;
        });
      }
    },

    clickState(state, index) {
      console.log("leftBar clickState Action state = ", state);
      console.log("leftBar clickState Action index = ", index);
      if (state === "离开") {
        this.$emit("leaveState", this.nowState);
        return;
      }
      // 记录切换前状态，接口失败时回滚
      this.prevStatusSnapshot = Number(this.iState);
      if (state === "在线") {
        this.applyLocalStatus(1, state);
      } else if (state === "忙碌") {
        this.applyLocalStatus(2, state);
      }
    },

    async setStateRequest() {
      console.log("leftBar setStateRequest iState = ", this.iState);
      const requestStatus = Number(this.iState);
      const rollbackStatus =
        this.prevStatusSnapshot === undefined || this.prevStatusSnapshot === null
          ? requestStatus
          : Number(this.prevStatusSnapshot);
      var api = "/manager/chat/setStatus";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          status: requestStatus,
        },
      });

      console.log("leftBar setStateRequest response = ", response);
      if (response && response.resultCode === "10000") {
        this.prevStatusSnapshot = requestStatus;
        this.applyLocalStatus(
          requestStatus,
          requestStatus === 1 ? "在线" : requestStatus === 2 ? "忙碌" : "离开",
          { skipRequest: true }
        );
      } else {
        const rollbackName =
          rollbackStatus === 1 ? "在线" : rollbackStatus === 2 ? "忙碌" : "离开";
        this.applyLocalStatus(rollbackStatus, rollbackName, {
          skipRequest: true,
        });
        this.$message({
          message: (response && response.desc) || "状态切换失败",
          type: "warning",
        });
      }
    },

    goSessionReport(version) {
      this.sessionReportPopVisible = false;
      if (version === "old") {
        this.clickIcon(2, "会话统计");
      } else {
        const routeUrl = this.$router.resolve({
          name: "sessionReportNew",
        });
        const userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf("electron/") > -1) {
          const width = window.screen.availWidth * 0.8;
          const height = window.screen.availHeight * 0.8;
          const iTop = (window.screen.availHeight - 30 - 720) / 2;
          const iLeft = (window.screen.availWidth - 30 - 1280) / 2;
          this.$electron.ipcRenderer.send("new-window", {
            url: routeUrl.href,
            title: "会话统计-新版",
            config: {
              height,
              width,
              top: iTop,
              left: iLeft,
            },
          });
        } else {
          window.location.href = routeUrl.href;
        }
      }
    },

    clickIcon(index, title) {
      console.log("leftBar clickIcon index = ", index, title);
      // var userAgent = navigator.userAgent.toLowerCase()
      // if (userAgent.indexOf('electron/') > -1) {
      // 	return;
      // }
      // if (index === 0) {
      // 	this.logSelected = true
      // 	this.reportSelected = false
      // 	this.talkSelected = false
      // 	this.wordSelected = false
      // 	this.settingSelected = false

      // } else if (index === 1) {
      // 	this.logSelected = false
      // 	this.reportSelected = true
      // 	this.talkSelected = false
      // 	this.wordSelected = false
      // 	this.settingSelected = false
      // } else if (index === 2) {
      // 	this.logSelected = false
      // 	this.reportSelected = false
      // 	this.talkSelected = true
      // 	this.wordSelected = false
      // 	this.settingSelected = false
      // } else if (index === 3) {
      // 	this.logSelected = false
      // 	this.reportSelected = false
      // 	this.talkSelected = false
      // 	this.wordSelected = true
      // 	this.settingSelected = false

      // } else if (index === 4) {
      // 	this.logSelected = false
      // 	this.reportSelected = false
      // 	this.talkSelected = false
      // 	this.wordSelected = false
      // 	this.settingSelected = true
      // }
      console.log(
        "leftBar clickIcon navigator.userAgent:",
        navigator.userAgent
      );
      var userAgent = navigator.userAgent.toLowerCase();
      console.log("leftBar clickIcon userAgent:", userAgent);
      let routeUrl = this.$router.resolve({
        name: "setting",
        query: {
          enterId: index,
          name: title,
        },
      });
      console.log("routeUrl", routeUrl);

      if (userAgent.indexOf("electron/") > -1) {
        console.log("leftBar.vue    electron环境");
        //打包版本
        const width = window.screen.availWidth * 0.8;
        const height = window.screen.availHeight * 0.8;
        let iTop = (window.screen.availHeight - 30 - 720) / 2;
        let iLeft = (window.screen.availWidth - 30 - 1280) / 2;
        let hrefIndex = "" + index;
        console.log(
          "this.$store.state.hrefData[hrefIndex]",
          this.$store.state.hrefData,
          this.$store.state.hrefData[hrefIndex],
          hrefIndex
        );
        const ipc = this.$electron.ipcRenderer;
        ipc.send("new-window", {
          url: routeUrl.href,
          title,
          config: {
            height: height,
            width: width,
            top: iTop,
            left: iLeft,
          },
        });
        console.log(config);
        // if (this.$store.state.hrefData[hrefIndex] === undefined) {
        //   this.$store.state.hrefData[hrefIndex] = window.open(
        //     routeUrl.href,
        //     title,
        //     `height=720,width=1280,top=${iTop},left=${iLeft}`
        //   );
        //   // console.log('this.$store.state.hrefData[hrefIndex]',this.$store.state.hrefData[hrefIndex])
        //   //        setTimeout(() => {
        //   //          this.$store.state.hrefData[hrefIndex].document.title = title;
        //   //        }, 300);
        //   config.setHrefData(this.$store.state.hrefData);
        // } else {
        //   if (this.$store.state.hrefData[hrefIndex].closed == true) {
        //     this.$store.state.hrefData[hrefIndex] = window.open(
        //       routeUrl.href,
        //       title,
        //       `height=720,width=1280,top=${iTop},left=${iLeft}`
        //     );
        //     // console.log('this.$store.state.hrefData[hrefIndex]',this.$store.state.hrefData[hrefIndex])
        //     //          setTimeout(() => {
        //     //            this.$store.state.hrefData[hrefIndex].document.title = title;
        //     //          }, 300);
        //     config.setHrefData(this.$store.state.hrefData);
        //   } else {
        //     // this.$store.state.hrefData[hrefIndex].blur();
        //     this.$store.state.hrefData[hrefIndex].focus();
        //     // setTimeout(() => {

        //     // }, 500);
        //     // setTimeout(() => {
        //     // 	this.$store.state.hrefData[hrefIndex] = window.open(
        //     // 		routeUrl.href,
        //     // 		title,
        //     // 		`height=720,width=1280,top=${iTop},left=${iLeft}`
        //     // 	);
        //     // 	setTimeout(() => {
        //     // 		this.$store.state.hrefData[hrefIndex].document.title = title;
        //     // 	}, 300);
        //     // }, 200)
        //     // config.setHrefData(this.$store.state.hrefData);
        //   }
        // }
      } else {
        console.log("leftBar.vue    浏览器环境");
        //浏览器版本
        window.location.href = routeUrl.href;
        // window.open(routeUrl.href, "_blank");
        console.log(router);
      }
    },
    //页面跳转
    // linkTo(val) {
    //   var userAgent = navigator.userAgent.toLowerCase();
    //   let routeUrl = this.$router.resolve({
    //     name: "setting",
    //     query: {
    //       enterId: val,
    //     },
    //   });
    //   if (userAgent.indexOf("electron/") > -1) {
    //     //打包版本
    //     window.open(routeUrl.href, "_blank");
    //   } else {
    //      //浏览器版本
    //      window.location.href = routeUrl.href;
    //   }
    //   // else {
    //   //   //浏览器版本
    //   //   window.location.href = "http://localhost:3000" + routeUrl.href;
    //   // }
    // },
    // 上传头像相关接口
    handleAvatarSuccess(res, file) {
      this.imgUrl = this.util.getLocalImgUrl() + res.data.fileUrl;
      console.log("图片URL", this.imgUrl);
      console.log("上传图片成功", res);
      console.log(file);

      var account = this.util.getLocalAccount();
      account.logoUrl = this.imgUrl;
      this.util.setLocalAccount(JSON.stringify(account));
      console.log("MyMessage 头像url = ", account.logoUrl);
      this.onSubmit(account);
    },
    async onSubmit(account) {
      console.log("MyMessage onSubmit");
      var api = "/manager/user/updateUserMessage";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          logoUrl: this.imgUrl,
          tel: account.tel,
          nickName: account.nickName,
        },
      });
      if (response.resultCode === "10000") {
        const tipMsg = "基础信息修改成功！";
        console.log(tipMsg);
      } else {
        this.$message.error(response.desc);
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/png" || "image/jpg" || "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG/JPEG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    setNavIconSize() {
      const h = document.documentElement.clientHeight;
      let size;
      if (h <= 800) {
        size = 32;
      } else {
        const hei = (h - 360) / 6;
        size = hei > 65 ? 60 : Math.max(32, hei - 5);
      }
      size = Math.round(size * 0.8);
      $(".img_div").css("height", size + "px");
      $(".img_div").css("width", size + "px");
    },
    // zoomout() {
    // 	this.afterWidth = document.body.clientWidth
    // 	var size=this.afterWidth / this.leftBarWidth;
    // 	document.body.style.zoom = size;
    // 	document.body.style.cssText += '; -moz-transform: scale(' + size + ');-moz-transform-origin: 0 0; ';     //
    // }
  },
};
</script>

<style scoped="scoped" lang="scss">
.left_container {
  width: var(--sidebar-w, 57px);
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-content: space-between;
  justify-content: space-between;
  background-color: #26292c;
  position: absolute;
  left: 0;
  top: 0;
}

.head_div {
  width: 100%;
  // height: 320px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.header_icon {
  border-radius: 0.25rem;
  width: var(--sidebar-avatar, 1.85rem);
  height: var(--sidebar-avatar, 1.85rem);
  box-shadow: 0px 0px 3px 0px #85a9e4;
  margin: 0 auto;
  margin-top: 1.2rem;
}

.online_text,
.busy_text,
.leave_text {
  @include change_tip_size($tip_size_normal);
  font-size: 10px !important;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: bold;
  width: 100%;
  height: auto;
  margin: 0 auto;
  margin-top: 7px;
  list-style-type: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  line-height: 1.25;
}

.font_type {
  // width: 3.75rem;
  // height: 1.5rem;
  width: 40px;
  height: 20px;
  // background: #FFFFFF;
  border-radius: 0.125rem;
  border: 0.0625rem solid rgba(0, 0, 0, 0.15);
  @include change_tip_size($tip_size_normal);
  font-size: 10px !important;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  // color: rgba(0, 0, 0, 0.65);
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 0.42rem;
  cursor: pointer;
}

.online_tip,
.busy_tip,
.leave_tip {
  width: 0.35rem;
  height: 0.35rem;
  background-color: #5a9cf8;
  border-radius: 50%;
  margin-right: 0.2rem;
}

.busy_tip {
  background-color: #f85a5a;
}

.leave_tip {
  background-color: #444444;
}

.op_div {
  width: 100%;
  // height: calc(100% - 550px);
  display: flex;
  flex-direction: column;
  //   justify-content: space-between;
  align-items: center;
  margin-bottom: 27px;
  background-color: rgba(90, 156, 248, 0);
  & > div {
    margin-top: 7px;
  }
}

.session-report-ref {
  display: inline-block;
  cursor: pointer;
}

.session-report-options {
  .session-report-option {
    padding: 8px 12px;
    cursor: pointer;
    font-size: 14px;
    color: #303133;
    &:hover {
      background: #f5f7fa;
      color: #409eff;
    }
  }
}

.img_div {
  width: calc(var(--sidebar-w, 57px) - 8px);
  height: calc(var(--sidebar-w, 57px) - 8px);
  max-width: 72px;
  max-height: 72px;
  margin-top: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon_img {
  width: var(--sidebar-icon, 20px);
  height: var(--sidebar-icon, 20px);
}

.avatar-uploader .el-upload :deep() {
  border: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: default !important;
}

.header_nickname {
  /* font-size: 0.75rem;
		font-family: PingFang-SC-Regular, PingFang-SC;
		font-weight: 400;
		color: #444444; */
  @include change_tip_size($tip_size_normal);
  font-size: 10px !important;
  line-height: 0.75rem;
  width: var(--sidebar-nick-w, 52px);
  max-width: calc(var(--sidebar-w, 57px) - 4px);
  margin-top: 0.35rem;
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-left: 0;
  // color: #f5f5f5;
  /* background-color: orange; */
}

.version_div {
  font-size: 0.5rem;
  text-align: center;
  // margin-left: 0.25rem;
  color: rgba(137, 137, 137, 0.6);
  width: 100%;
  height: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.statusList {
  display:flex;
  flex-direction:column;
  padding-bottom: 13px;
}

html[data-compact="1"] {
  .left_container {
    width: var(--sidebar-w, 43px);
  }
  .header_icon {
    width: var(--sidebar-avatar, 19px) !important;
    height: var(--sidebar-avatar, 19px) !important;
    margin-top: 6px;
  }
  .header_nickname {
    width: var(--sidebar-nick-w, 40px);
    margin-top: 2px;
    font-size: 9px !important;
    line-height: 12px;
  }
  .online_text,
  .busy_text,
  .leave_text {
    height: auto;
    margin-top: 3px;
    font-size: 9px !important;
  }
  .font_type {
    width: 30px;
    height: 16px;
    margin-top: 3px;
    font-size: 9px !important;
  }
  .op_div {
    margin-bottom: 6px;
    & > div {
      margin-top: 3px;
    }
  }
  .img_div {
    width: 30px !important;
    height: 30px !important;
    margin-top: 0;
  }
  .icon_img {
    width: var(--sidebar-icon, 12px);
    height: var(--sidebar-icon, 12px);
  }
  .version_div {
    height: 16px;
    font-size: 8px;
  }
  .statusList {
    padding-bottom: 6px;
  }
}

/* 大屏：侧栏加宽后同步放大文字与点击区域 */
html[data-wide="1"] {
  .header_icon {
    margin-top: 1.4rem;
  }
  .header_nickname {
    font-size: 11px !important;
    line-height: 14px;
  }
  .online_text,
  .busy_text,
  .leave_text {
    font-size: 11px !important;
  }
  .font_type {
    width: 48px;
    height: 22px;
    font-size: 11px !important;
  }
  .img_div {
    margin-top: 4px;
  }
}
</style>
